import React, { useEffect, useState, useId } from 'react'
import CustomTextarea from 'Common/CustomTextArea'
import FullPageLoader from 'Components/FullPageLoader/FullPageLoader'
import { ErrorHandlingMessage } from 'Utils/ErrorHandlingMessage'
import api from 'http'
import { toast } from 'react-toastify'
import Validator, { ValidationTypes as V_Type, } from 'react-form-supervalidator';
import CustomButtonNew from 'Common/CustomButtonNew/CustomButtonNew'
import CustomDraggable from 'Common/CustomDraggable/CustomDraggable'
import ReactPortal from 'Components/ReactPortal/ReactPortal'
import CustomSelect from 'Common/CustomSelect/CustomSelect'
import { SAVED_SUCCESSFULLY } from 'Common/ToastConstants'


const INITIALMODEL = {
    visitID: 0,
    claimStatusCode: "",
    primaryStatus: "",
    secondaryStatus: "",
    tertiaryStatus: "",
    patientStatus: "",
    notes: ""
}

const ChangeClaimStatusPopup = ({ onClose, row, disableDraggable }) => {
    const uniqueId = "ChangeClaimStatusPopup"
    const [data, setData] = useState([]);
    const [state, setState] = useState(INITIALMODEL);
    const [loading, setLoading] = useState(false);
    const uniqueID = useId();
    const [validationModel, setValidationModel] = useState({
        claimStatusCodeError:null,
        notesError: null,
    })
    const handleChange = (e) => {
        let { name, value } = e.target
        setState((prev) => ({
            ...prev,
            [name]: value
        }))
    }

    const setValidation = () => {
        let validation_Obj = {
            ...validationModel,
            notesError: Validator(state.notes, [V_Type.required], ['Notes is required'],),
            claimStatusCodeError: Validator(state.claimStatusCode, [V_Type.required], ['Claim status is required'],),
        }
        setValidationModel(validation_Obj)
        return Validator(validation_Obj, V_Type.NullCheck);
    }
    const handleSaveIns = async () => {
        let my_validation = setValidation();
        if (my_validation) {

        }
        else {
            try {
                const payload = {
                    visitID: row.id,
                    claimStatusCode: state.claimStatusCode,
                    primaryStatus: state.primaryStatus,
                    secondaryStatus: state.secondaryStatus,
                    tertiaryStatus: state.tertiaryStatus,
                    patientStatus: state.patientStatus,
                    notes: state.notes
                }
                setLoading(true)
                await api.post(`${process.env.REACT_APP_TC_PMS}/api/Visit/ChangeVisitStatus`, payload);
                toast.success(SAVED_SUCCESSFULLY)
                onClose()
            } catch (error) {
                ErrorHandlingMessage(error)
            } finally {
                setLoading(false);
            }
        }

    }

    useEffect(() => {
        (async () => {
            try {
                setState((prev) => ({
                    ...prev,
                    secondaryStatus: row.secondaryStatus,
                    tertiaryStatus: row.tertiaryStatus,
                    claimStatusCode: row.claimStatusCode,
                    patientStatus: row.patientStatus,
                    primaryStatus: row.primaryStatus
                }));
                setLoading(true)
                const response = await api.get(`${process.env.REACT_APP_TC_PMS}/api/Visit/FindVisitStatusCodes`);
                setData(response.data.dataModel);
            } catch (error) {
                ErrorHandlingMessage(error);
            } finally {
                setLoading(false);
            }
        })();
    }, [row.secondaryStatus, row.tertiaryStatus, row.claimStatusCode, row.patientStatus, row.primaryStatus])

    return (
        <ReactPortal wrapperId={uniqueId}>
            {loading && <FullPageLoader allowFullScreen={true} />}
            <div
                data-te-modal-init
                className="fixed inset-0 z-10 flex items-center justify-center bg-gray-500 bg-opacity-75"
                id="exampleModalScrollable"
                tabIndex={-1}
                aria-labelledby="exampleModalScrollableLabel"
                aria-modal="true"
                data-te-open="true"
            >
                <CustomDraggable disableDraggable={disableDraggable} handle={`#${uniqueId}`}>
                    <div
                        data-te-modal-dialog-ref
                        className="relative w-[600px] min-[576px]:mx-auto min-[576px]:mt-2 min-[576px]:max-w-[500px] min-[992px]:max-w-[800px] min-[1200px]:max-w-[1140px] flex flex-col overflow-hidden rounded-md bg-white shadow-lg"
                    >
                        {/* Header */}
                        <div
                            id={uniqueId}
                            className="flex items-center justify-between p-5 text-2xl font-semibold border-b cursor-grab"
                        >
                            Change Claim Status
                            <button onClick={onClose} className="p-1.5 shrink-0 rounded border border-slate-200 hover:border-slate-300 shadow-sm ml-2">
                                <img src="/img/crossblack.svg" alt="cross" />
                            </button>
                        </div>
                        <div className="px-5 pt-5 overflow-y-auto max-h-[70vh]">
                            <div className="grid grid-cols-12 gap-4">
                                <div className='col-span-4'>
                                    <CustomSelect value={state.claimStatusCode} required name="claimStatusCode" onChange={handleChange} label={"Claim Status"} children={row.claimStatusCode}  >
                                        <option value="">Please Select</option>
                                        {data.filter((item) => item.isClaimStatus).map((item) => <option key={uniqueID + item.statusCode} value={item.statusCode}>{item.statusDescription}</option>)}
                                    </CustomSelect>
                                    {validationModel.claimStatusCodeError}
                                </div>
                                <div className='col-span-4'>
                                    <CustomSelect value={state.primaryStatus} name="primaryStatus" onChange={handleChange} label={"Primary"} children={row.primaryStatus}  >
                                        <option value="">Please Select</option>
                                        {data.filter((item) => item.isInsuranceStatus).map((item) => <option key={uniqueID + item.statusCode} value={item.statusCode}>{item.statusDescription}</option>)}
                                    </CustomSelect>
                                </div>
                                <div className='col-span-4'>
                                    <CustomSelect value={state.secondaryStatus} name="secondaryStatus" onChange={handleChange} label={"Secondary"} children={row.secondaryStatus}  >
                                        <option value="">Please Select</option>
                                        {data.filter((item) => item.isInsuranceStatus).map((item) => <option key={uniqueID + item.statusCode} value={item.statusCode}>{item.statusDescription}</option>)}
                                    </CustomSelect>
                                </div>
                                <div className='col-span-4'>
                                    <CustomSelect value={state.tertiaryStatus} name="tertiaryStatus" onChange={handleChange} label={"Tertiary"} children={row.tertiaryStatus} >
                                        <option value="">Please Select</option>
                                        {data.filter((item) => item.isInsuranceStatus).map((item) => <option key={uniqueID + item.statusCode} value={item.statusCode}>{item.statusDescription}</option>)}
                                    </CustomSelect>
                                </div>
                                <div className='col-span-4'>
                                    <CustomSelect value={state.patientStatus} name="patientStatus" onChange={handleChange} label={"Patient"} children={row.patientStatus}  >
                                        <option value="">Please Select</option>
                                        {data.filter((item) => item.isPatientStatus).map((item) => <option key={uniqueID + item.statusCode} value={item.statusCode}>{item.statusDescription}</option>)}
                                    </CustomSelect>
                                </div>
                            </div>
                            <div className="grid grid-cols-1 pt-4">
                                <CustomTextarea value={state.notes} name={"notes"} onChange={handleChange} label="Notes" type="textarea" placeholder="Notes" required />
                                {validationModel.notesError}
                            </div>
                        </div>

                        {/* Footer */}
                        <div className="flex flex-wrap items-center justify-end gap-2 p-5 ">
                            <CustomButtonNew variant={"outline"} label={"Cancel"} onClick={onClose} />
                            <CustomButtonNew label={row.id ? "Update" : "Save"} onClick={handleSaveIns} />
                        </div>
                    </div>
                </CustomDraggable>
            </div>
        </ReactPortal>
    )
}

export default ChangeClaimStatusPopup
